
export const SOCKET_URL: string = 'https://chat.sooqdev1.com/'


